module.exports = __webpack_public_path__ + "img/earth1.cb82676a.png";